angular.module('app').directive('requiredField', ['$timeout', function ($timeout) {
    return {
        //scope: true,   // optionally create a child scope
        restrict: "A",
        require: '?ngModel',
        link: function (scope, element, attrs,ngModel) {
          element.bind("blur", function () {
              if (!ngModel.$viewValue){
                  scope.tooltip[attrs.name] = attrs.requiredField;
              }
          });

        }
    };
}]);